(function () {
  const LIMIT = 250;
  const MAX_DESIGN_ITEMS = 14;

  const script = document.currentScript || document.querySelector('script[src*="collection-product-design-menu.js"]');
  const filesBaseUrl = (script && script.dataset.assetsBase) || '';

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getImageFilename(designName) {
    if (!designName) return '';
    const slug = designName
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-');
    return slug ? slug + '.png' : '';
  }

  function getImageSrc(designName) {
    const filename = getImageFilename(designName);
    return filename && filesBaseUrl ? filesBaseUrl + filename : '';
  }

  function getDesignOptionValue(variant, product) {
    const options = product.options || [];
    for (let i = 0; i < options.length; i++) {
      const opt = options[i];
      const name = (typeof opt === 'string' ? opt : (opt && opt.name) || opt || '').toString().toLowerCase();
      if (name === 'design') {
        const val = variant['option' + (i + 1)];
        if (val) return String(val).trim();
      }
    }
    return '';
  }

  function getDesignDisplayName(variant, product) {
    const fromOption = getDesignOptionValue(variant, product);
    if (fromOption) return fromOption;

    let name = (variant.title || variant.option1 || product.title || '').toString().trim();
    const slashIndex = name.indexOf('/');
    if (slashIndex > -1) name = name.slice(0, slashIndex).trim();
    name = name.replace(/\s+\d+$/, '').trim();
    return name;
  }

  function renderDesignItem(item) {
    const imageSrc = getImageSrc(item.title);
    const alt = escapeHtml(item.title);

    return `<li>
      <a href="${escapeHtml(item.href)}" class="collection-design-menu__link grid gap-3 hover-wrapper reversed-link">
        <div class="overflow-hidden blocks-radius-md">
          <div class="media-wrapper" style="--aspect-ratio: 1;">
            <img
              src="${escapeHtml(imageSrc)}"
              alt="${alt}"
              loading="lazy"
              width="220"
              class="motion-reduce hover-scale-up w-full"
            >
          </div>
        </div>
      </a>
    </li>`;
  }

  async function fetchAllProducts(collectionHandle) {
    let page = 1;
    let hasMore = true;
    const allProducts = [];

    while (hasMore) {
      const res = await fetch(`/collections/${collectionHandle}/products.json?limit=${LIMIT}&page=${page}`);
      if (!res.ok) break;
      const data = await res.json();
      const products = (data && data.products) || [];
      allProducts.push(...products);
      hasMore = products.length === LIMIT;
      page += 1;
    }

    return allProducts;
  }

  async function hydrateList(listEl) {
    const handle = listEl && listEl.getAttribute('data-collection-handle');
    if (!handle || listEl.getAttribute('data-hydrated') === 'true') return;
    listEl.setAttribute('data-hydrated', 'loading');

    try {
      const products = await fetchAllProducts(handle);
      const seen = new Set();
      const items = [];

      for (const product of products) {
        const variants = product.variants || [];
        for (const variant of variants) {
          const designTitle = getDesignDisplayName(variant, product);
          if (!designTitle) continue;
          const key = designTitle.toLowerCase();
          if (seen.has(key)) continue;
          seen.add(key);

          const href = `/collections/${handle}?filter.v.option.design=${encodeURIComponent(designTitle).replace(/%20/g, '+')}`;

          items.push({ title: designTitle, href });
          if (items.length >= MAX_DESIGN_ITEMS) break;
        }
        if (items.length >= MAX_DESIGN_ITEMS) break;
      }

      listEl.setAttribute('data-hydrated', 'true');

      if (!items.length) {
        listEl.innerHTML = '';
        return;
      }

      listEl.innerHTML = items.map(renderDesignItem).join('');
    } catch (e) {
      listEl.setAttribute('data-hydrated', 'error');
      console.error('Collection product design menu:', e);
    }
  }

  function hydrateAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-collection-product-design]:not([data-hydrated="true"])').forEach(hydrateList);
  }

  function init() {
    hydrateAll(document);

    document.querySelectorAll('details-mega, details[is="details-mega"], .mega-menu details, .menu-drawer details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (details.open) hydrateAll(details);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target && event.target.classList.contains('header-section')) {
      hydrateAll(event.target);
    }
  });
})();
